import workspace from "../workspace";
import sqftShapeManager from "../../store/sqftShapeManager";
import Rectangle from "../shapes/layouts/rectangle";
import {CABINET_LABELS, SHAPE_PART_ID} from "../../../../constants";
import Polygon from "../shapes/layouts/polygon";
import SlabAdditionalShape from "../slab/slabAdditionalShape";
import {createIroningBoardShape} from "./cabinetShapesSpecialLayouts";
import {getCabinetDimensions, getRelatedFeatureMetadata, getSpecialShape} from "../../../../helpers/sqft3dArHelper";

export const SHAPE_LAYOUTS = {
  rectangle: "rectangle",
  upperLayoutType1: "upperLayoutType1",
  upperLayoutType2: "upperLayoutType2",
  lowerLayoutType1: "lowerLayoutType1",
  lowerLayoutType2: "lowerLayoutType2",
  lowerLayoutType3: "lowerLayoutType3",
  lowerLayoutType4: "lowerLayoutType4",
  lowerLayoutType5: "lowerLayoutType5",
};

export const SHAPE_UPPER_LAYOUTS = [
  SHAPE_LAYOUTS.upperLayoutType1,
  SHAPE_LAYOUTS.upperLayoutType2,
];

export const SHAPE_LOWER_LAYOUTS = [
  SHAPE_LAYOUTS.lowerLayoutType1,
  SHAPE_LAYOUTS.lowerLayoutType2,
  SHAPE_LAYOUTS.lowerLayoutType3,
  SHAPE_LAYOUTS.lowerLayoutType4,
  SHAPE_LAYOUTS.lowerLayoutType5,
];

export const SHAPE_SQUARE_LAYOUTS = [
  SHAPE_LAYOUTS.upperLayoutType1,
  SHAPE_LAYOUTS.lowerLayoutType1,
  SHAPE_LAYOUTS.lowerLayoutType2,
  SHAPE_LAYOUTS.lowerLayoutType4,
  SHAPE_LAYOUTS.lowerLayoutType5,
];

// const LAYOUT_TYPES = {
//   upper: SHAPE_UPPER_LAYOUTS,
//   lower: SHAPE_LOWER_LAYOUTS,
// };

class CabinetShapes {
  constructor() {
    this.upperShapes = [];
    this.lowerShapes = [];
    this.otherShapes = [];
    this.additionalShapes = [];
    this.shapes = {
      /**
       *   |‾‾‾‾|
       *   |    /
       *   |__/
      */
      upperLayoutType1: [
        'SM-DCW2436', 'SW-DCW2430', 'SM-DCW2442',
        'Providence Cabinets Shaker White 27" W, 36" H Diagonal Corner Wall Cabinet',
        'Providence Cabinets Shaker White 27" W, 42" H Diagonal Corner Wall Cabinet',
        'SW-W1230', 'SM-W1236', 'SM-W1242',
      ],
      /**
      *   |‾‾‾‾|
      *   |   _|
      *   |__|
      */
      upperLayoutType2: [
        'Providence Cabinets Shaker White Corner Wall Cabinet 24"W 36" H',
        'Providence Cabinets Shaker White 24" W, 30" H Diagonal Corner Wall Cabinet',
        'Providence Cabinets Shaker White Corner Wall Cabinet 24"W 30"H',
        'Providence Cabinets Shaker White Corner Wall Cabinet 24"W 42"H',
        'Providence Cabinets Shaker White Corner Wall Cabinet 24"W 42" H',
      ],
      /**
       *   |‾‾‾‾‾|
       *   |   __|
       *   |__|
      */
      lowerLayoutType1: ['SM-ERB36/BER36', 'Providence Cabinets Shaker White 33" Lazy Susan'],
      /**
       *   |‾‾‾/
       *   |  >
       *   |/
      */
      lowerLayoutType2: ['SW-BEC24'],
      /**
       *   |‾‾‾|
       *   |   |
       *   | )
       */
      lowerLayoutType3: ['SW-BES12'],
      /**
       *   |‾‾‾‾|
       *   |    /
       *   |__/
       */
      lowerLayoutType4: [],
    };
    this.specialShapes = {
      LowerLCorner: SHAPE_LAYOUTS.lowerLayoutType1,
      LowerDullangle: SHAPE_LAYOUTS.lowerLayoutType2,
      LowerDualangle: SHAPE_LAYOUTS.lowerLayoutType2,
      LowerIroningBoard: SHAPE_LAYOUTS.lowerLayoutType3,
      LowerDimondShape: SHAPE_LAYOUTS.lowerLayoutType4,
      LowerDimondCorner: SHAPE_LAYOUTS.lowerLayoutType5,
      UpperDimondCorner: SHAPE_LAYOUTS.upperLayoutType1,
      UpperLCorner: SHAPE_LAYOUTS.upperLayoutType2,
    }
  }

  addShape = (feature, parentFeature, position = null) => {
    const dimensions = getCabinetDimensions(feature, parentFeature);
    if (feature.partId === CABINET_LABELS.upper_cabinet_boxes) {
      return this.addShapeHelper(
        this.upperShapes, 'square', feature.partId,
        this.getShapeLayout(feature, parentFeature), dimensions, position, feature, parentFeature
      );
    } else if (feature.partId === CABINET_LABELS.lower_cabinet_boxes) {
      return this.addShapeHelper(
        this.lowerShapes, 'square', feature.partId,
        this.getShapeLayout(feature, parentFeature), dimensions, position, feature, parentFeature
      );
    } else {
      return this.addShapeHelper(
        this.otherShapes, 'square', feature.partId,
        this.getShapeLayout(feature, parentFeature), dimensions, position, feature, parentFeature
      );
    }
  };

  addShapeHelper = (shapeArray, shapeType, partId, shapeLayout, dimensions, position, feature, parentFeature) => {
    const shapeLines = this.getShapeLines(shapeLayout, dimensions);
    const shapeParams = { shapeCabinet: true, canSnap: true, ...dimensions, shapeLayout };
    const shapeId = sqftShapeManager.addShape(shapeLines, shapeType, position, partId, null, shapeParams);
    sqftShapeManager.setShapeFeatureId(shapeId, feature.dbFeature.id);
    sqftShapeManager.setShapeRelatedParentFeatureId(shapeId, parentFeature.dbFeature.id);
    shapeArray.push(shapeId);
    return shapeId;
  };

  getShapeLayout = (feature, parentFeature) => {
    const thirdPartyAR3DMetaData = getRelatedFeatureMetadata(feature, parentFeature);
    const specialShape = getSpecialShape(thirdPartyAR3DMetaData);
    if (specialShape) {
      const specialLayoutName = specialShape.replace(/\s/g, "");
      if (this.specialShapes[specialLayoutName]) {
        return this.specialShapes[specialLayoutName]
      }
    }

    // for (const layout of LAYOUT_TYPES[type]) {
    //   if (feature.dbFeature && this.shapes[layout].includes(feature.dbFeature.sharedFeatureName) ||
    //     (feature.part && this.shapes[layout].includes(feature.part.dbFeature.sharedFeatureName))) {
    //     return layout;
    //   }
    // }
    return SHAPE_LAYOUTS.rectangle;
  };

  getShapeLines = (shapeLayout, { width, height, depth }) => {
    void height;
    switch (shapeLayout) {
      case SHAPE_LAYOUTS.lowerLayoutType1:
        return new Polygon(this.createPoints([
          { x: 0, y: 0 },
          { x: width, y: 0 },
          { x: width, y: depth },
          { x: depth, y: depth },
          { x: depth, y: width },
          { x: 0, y: width }
        ]), true, true);
      case SHAPE_LAYOUTS.lowerLayoutType2:
        return new Polygon(this.createPoints([
          { x: 0, y: 0 },
          { x: width, y: 0 },
          { x: width - 8, y: depth - 8 },
          { x: 0, y: depth }
        ]), true, true);
      case SHAPE_LAYOUTS.lowerLayoutType3:
        return createIroningBoardShape(width, depth, width);
      case SHAPE_LAYOUTS.lowerLayoutType4:
        return new Polygon(this.createPoints([
          { x: 0, y: 0 },
          { x: width, y: 0 },
          { x: width, y: depth },
          { x: depth, y: width },
          { x: 0, y: width }
        ]), true, true);
      case SHAPE_LAYOUTS.lowerLayoutType5:
        return new Polygon(this.createPoints([
          { x: width - depth, y: 0 },
          { x: width, y: 0 },
          { x: width, y: depth },
          { x: depth, y: depth },
          { x: depth, y: width },
          { x: 0, y: width },
          { x: 0, y: width - depth }
        ]), true, true);
      // UPPER
      case SHAPE_LAYOUTS.upperLayoutType1:
        return new Polygon(this.createPoints([
          { x: 0, y: 0 },
          { x: width, y: 0 },
          { x: width, y: width - depth },
          { x: width - depth, y: width },
          { x: 0, y: width }
        ]), true, true);
      case SHAPE_LAYOUTS.upperLayoutType2:
        return new Polygon(this.createPoints([
          { x: 0, y: 0 },
          { x: width, y: 0 },
          { x: width, y: depth },
          { x: depth, y: depth },
          { x: depth, y: width },
          { x: 0, y: width }
        ]), true, true);
      default:
        return new Rectangle(width, depth);
    }
  };

  createPoints = (coords) => coords;

  resetUpperShapes = () => {
    this.upperShapes = [];
  };

  importData = (data) => {
    //this.resetBacksplashes();
    data.forEach(activeBacksplashData => {
      const shape = workspace.importShape(activeBacksplashData.backsplashShape);
      shape.deregisterEvents();
      const line = workspace.getLineById(activeBacksplashData.line.id);
      const slabAdditionalShape = new SlabAdditionalShape(line, shape.id);
      this.addActiveBacksplash(slabAdditionalShape);
    });
  };

  exportData = () => {
    return this.additionalShapes
      .filter(slab => workspace.getShapeById(slab.backsplashShapeId).partId !== SHAPE_PART_ID.seamPiece)
      .map(slab => ({
        backsplashShape: workspace.getShapeById(slab.backsplashShapeId).export(),
        line: slab.line.export(),
      }));
  };

  addActiveBacksplash = (slabAdditionalShape) => {
    this.additionalShapes.push(slabAdditionalShape);
  };

  findAdditionalShapeByLine = (line) => {
    return this.additionalShapes.find(additionalShape => additionalShape.line.id === line.id);
  };

  removeActiveBacksplashByLine = (line) => {
    this.additionalShapes = this.additionalShapes.filter(shape => {
      if (shape.line.id === line.id) {
        workspace.removeShapeById(shape.backsplashShapeId);
        return false;
      }
      return true;
    });
  };

  removeShapeFromList = (shapeToRemove) => {
    this.additionalShapes = this.additionalShapes.filter(additionalShape => additionalShape.backsplashShapeId !== shapeToRemove.id);
  };
}

export default CabinetShapes;
